<template>
    <div id="data">
        <el-tag>欢迎使用本系统</el-tag>
    </div>
</template>

<script>
    export default {
        name: "data-page",
        mounted(){

        }
    }
</script>

<style scoped lang="less">
#data{padding:15px;box-sizing: border-box;}
</style>